import { defineComponent as t, openBlock as a, createBlock as r, unref as p, mergeProps as l, withCtx as i, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ t({
  name: "IconShoppingBag",
  __name: "IconShoppingBag",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (d, e) => (a(), r(p(c), l(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M7.309 6.25a4.751 4.751 0 0 1 9.382 0H18.5a1.25 1.25 0 0 1 1.25 1.25v11a3.25 3.25 0 0 1-3.25 3.25h-9a3.25 3.25 0 0 1-3.25-3.25v-11A1.25 1.25 0 0 1 5.5 6.25h1.809m1.528 0a3.251 3.251 0 0 1 6.326 0H8.837M5.75 18.5V7.75h12.5V18.5a1.75 1.75 0 0 1-1.75 1.75h-9a1.75 1.75 0 0 1-1.75-1.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
